import React from "react";
import { NavLink } from "react-router-dom";

export const ActiveNavLink = React.forwardRef<any, any>(({children, ..._props}, ref) => (
    <NavLink
        ref={ref}
        to={_props.to}
        {..._props}
        className={({isActive}) => (isActive ? _props.className + ' Mui-selected' : _props.className)}
    >
        {children}
    </NavLink>
));